export const filterRelationshipManagers = admins => {
  return admins.filter(admin => !admin.isLendingManager && !admin.isAccountManager && admin.isRelationshipManager)
}
export const filterAccountManagers = admins => {
  return admins.filter(admin => admin.isAccountManager && !admin.isLendingManger && !admin.isRelationshipManager)
}
export const filterLendingManagers = admins => {
  return admins.filter(admin => admin.isLendingManager)
}
